"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var schemas_1 = require("@dcl/schemas");
var Atlas_1 = require("../Atlas/Atlas");
require("./NFTImage.css");
var utils_1 = require("./utils");
function NFTImage(_a) {
    var nft = _a.nft, className = _a.className;
    if (nft.category === schemas_1.NFTCategory.WEARABLE ||
        nft.category === schemas_1.NFTCategory.EMOTE) {
        var rarity = nft.category === schemas_1.NFTCategory.EMOTE
            ? nft.data.emote.rarity
            : nft.data.wearable.rarity;
        var _b = schemas_1.Rarity.getGradient(rarity), light = _b[0], dark = _b[1];
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-nft-image', className), style: { backgroundImage: "radial-gradient(".concat(light, ", ").concat(dark, ")") } },
            react_1.default.createElement("img", { className: "dui-nft-image__image", src: nft.image, alt: nft.name })));
    }
    if (nft.category === schemas_1.NFTCategory.ENS) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-nft-image--ens', className) },
            react_1.default.createElement("span", { className: ".dui-nft-image__subdomain" }, nft.data.ens.subdomain)));
    }
    if (nft.category === schemas_1.NFTCategory.ESTATE) {
        var parcels_1 = nft.data.estate.parcels;
        var _c = (0, react_1.useMemo)(function () { return (0, utils_1.getEstateCenter)(parcels_1); }, [parcels_1]), estateX = _c[0], estateY = _c[1];
        var selectedEstateStrokeLayer = (0, react_1.useCallback)(function (tileX, tileY) {
            return parcels_1.some(function (_a) {
                var x = _a.x, y = _a.y;
                return tileX === x && y === tileY;
            })
                ? { color: '#ff0044', scale: 1.4 }
                : null;
        }, [parcels_1]);
        var selectedEstateFillLayer = (0, react_1.useCallback)(function (tileX, tileY) {
            return parcels_1.some(function (_a) {
                var x = _a.x, y = _a.y;
                return tileX === x && y === tileY;
            })
                ? { color: '#ff9990', scale: 1.2 }
                : null;
        }, [parcels_1]);
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-nft-image--atlas', className) },
            react_1.default.createElement(Atlas_1.Atlas, { className: className, x: estateX, y: estateY, isDraggable: false, layers: [selectedEstateStrokeLayer, selectedEstateFillLayer] })));
    }
    if (nft.category === schemas_1.NFTCategory.PARCEL) {
        var x_1 = Number(nft.data.parcel.x);
        var y_1 = Number(nft.data.parcel.y);
        var selectedStrokeLayer = (0, react_1.useCallback)(function (tileX, tileY) {
            return x_1 === tileX && y_1 === tileY
                ? { color: '#ff0044', scale: 1.4 }
                : null;
        }, [x_1, y_1]);
        var selectedFillLayer = (0, react_1.useCallback)(function (tileX, tileY) {
            return x_1 === tileX && y_1 === tileY
                ? { color: '#ff9990', scale: 1.2 }
                : null;
        }, [x_1, y_1]);
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-nft-image--atlas', className) },
            react_1.default.createElement(Atlas_1.Atlas, { className: className, x: x_1, y: y_1, isDraggable: false, layers: [selectedStrokeLayer, selectedFillLayer] })));
    }
    return null;
}
exports.default = react_1.default.memo(NFTImage);
